import React from 'react'

import { StatusBadge } from "@driftt/dds"

export const EngageScoreBadge = ({engageScore, engageLevel}: { 
  engageScore: string,
  engageLevel: string
}) => {
  switch(engageLevel) {
    case 'Low':
      return (
        <StatusBadge variant='error'>{engageScore}</StatusBadge>
      )
    case 'Mid':
      return (
        <StatusBadge variant='warning'>{engageScore}</StatusBadge>
      )
    case 'High':
      return (
        <StatusBadge variant='success'>{engageScore}</StatusBadge>
      )
    default:
      return <>{engageScore}</>
  }
  
}